module.exports = __webpack_public_path__ + "img/wraith_band.e4fd4af0.png";